import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {HorizontalSliderComponent} from '../../../../elements/horizontal-slider/horizontal-slider.component';
import {Icons} from '../../../../../model/icon';
import {TextsComponent} from '../../../../elements/texts/texts.component';
import {NgIf} from '@angular/common';
import {Text} from '../../../../../model/text';
import {ArrowComponent} from '../../../../elements/arrow/arrow.component';
import {Card, CardsArray} from '../../../../../model/cards';
import {ThemeService} from '../../../../../services/theme.service';

@Component({
  selector: 'app-main-busy-bee',
  imports: [
    HorizontalSliderComponent,
    TextsComponent,
    NgIf,
    ArrowComponent,
  ],
  templateUrl: './main-busy-bee.component.html',
  standalone: true,
  styleUrl: './main-busy-bee.component.scss'
})
export class MainBusyBeeComponent implements OnInit, OnChanges {
  constructor(public themeService: ThemeService) {}

  @ViewChild("horizontalSlider") appHorizontalSlider!: HorizontalSliderComponent;
  @Input() anotherTitle: boolean = false;
  @Input() daysTitle: boolean = false;

  @Input() texts: Text[] = [];
  @Input() cards: Card[] = [];
  @Input() grid: number = 2;

  soloSlide: boolean = false;
  textsArray: Text[] = [];

  isLeft: boolean = false;
  isRight: boolean = false;

  ngOnInit() {
    this.textsArray = this.texts;
    if (window.innerWidth < 769) {
      this.grid = 1;
    }
    if (this.grid == 1) {
      this.soloSlide = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['texts']) {
      this.textsArray = this.texts;
    }
  }

  clickLeftButton() {
    this.appHorizontalSlider.turnLeft();
  };

  clickRightButton() {
    this.appHorizontalSlider.turnRight();
  };

  checkPosition(event: {isAtStart: boolean, isAtEnd: boolean}) {
    this.isLeft = event.isAtStart;
    this.isRight = event.isAtEnd;
  }

  protected readonly Icons = Icons;
  protected readonly CardsArray = CardsArray;
}
